

const StepperItem = (props) => {
  const isVisited = props.number <= props.index;

  return (
    <>
      <div
        className={`h-[3px] grow md:h-[6px] ${
          isVisited ? "bg-lupa-brand" : "bg-lupa-divider"
        }`}
      />
    </>
  );
};

export default StepperItem;
